const keyboardDetection = () => {
	document.addEventListener('keydown', ({ key, metaKey, altKey }) => {
		if (key === 'Tab' && !metaKey && !altKey) {
			document.body.classList.add('user-is-tabbing');
		}
	});

	document.addEventListener('mousemove', () => {
		document.body.classList.remove('user-is-tabbing');
	});
};

export default keyboardDetection;


// WEBPACK FOOTER //
// ./scripts/modules/keyboardDetection.js